export enum ButtonData_Type {
  /** LINK - Regular link button */
  LINK = 'LINK',
  /** ACTION - Triggers custom action that is defined in plugin configuration by the consumer */
  ACTION = 'ACTION',
  UNRECOGNIZED = 'UNRECOGNIZED',
}